// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rmj4H","label":"styles_label__3c4mm"};